/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let deleteMsgApiURL = root.deleteMsgApiUrl.link;
let UserChatDetailsUrl = root.userChatDetailsUrl.link;
let allLeftChatListDetailsURL = root.allLeftChatListDetailsUrl.link;
let chatRoomPinnedApiURL = root.chatRoomPinnedApiUrl.link;
let chatRoomPinnedListApiURL = root.chatRoomPinnedListApiUrl.link;
let forwardMultiMsgUserApiLink = root.forwardMultiMsgUserApiLink.link;
let chatWithUserSearchApiUrl = root.chatWithUserSearchApiUrl.link;
let getUserNameListFromGroupApiUrl = root.getUserNameListFromGroupApiUrl.link;
let groupDeleteApiUrl = root.groupDeleteApiUrl.link;
let messageSearchApiUrl = root.messageSearchApiUrl.link;
let workspaceUserSearchApiURL = root.workspaceUserSearchApiUrl.link;

let leaveGroupRoomApiURL = root.leaveGroupRoomApiUrl.link;
let updateGroupRoomDetailsApiURL = root.updateGroupRoomDetailsApiUrl.link;
let getGroupDetailsByIdApiURL = root.getGroupDetailsByIdApiUrl.link;
let makeUserToGroupAdminApiURL = root.makeUserToGroupAdminApiUrl.link;
let userRemovedFromGroupApiURL = root.userRemovedFromGroupApiUrl.link;
let removedAdminFromGroupApiUrl = root.removedAdminFromGroupApiUrl.link;


let fetchPinnedChatRoomsApiUrl = root.fetchPinnedChatRoomsApiUrl.link;
let fetchNormalChatRoomsApiUrl = root.fetchNormalChatRoomsApiUrl.link;

export default {
    state: {
        leftChatListDetailsState: {},
        pinnedChatRoomsState: {},
        groupUserNamesState: {},
        normalChatRoomsState: {},
        pinnedLoaded: false,
        normalLoaded: false
    },
    mutations: {
        SET_PINNED_LOADED(state, status) {
            state.pinnedLoaded = status;
        },

        SET_NORMAL_LOADED(state, status) {
            state.normalLoaded = status;
        },

        SET_LEFT_CHAT_LIST_DETAILS(state, value) {
            Vue.set(state, 'leftChatListDetailsState', value);
        },

        SET_GROUP_USER_NAMES(state, value) {
            Vue.set(state, 'groupUserNamesState', value);
        },

        SET_PINNED_CHAT_ROOMS(state, value) {
            Vue.set(state, 'pinnedChatRoomsState', value);
        },

        SET_NORMAL_CHAT_ROOMS(state, value) {
            Vue.set(state, 'normalChatRoomsState', value);
        },
        // Appends paginated infinite scroll results
        APPEND_NORMAL_CHAT_ROOMS(state, payload) {
            const stateNorm = state.normalChatRoomsState;
            const currentResults = stateNorm && stateNorm.results || [];
            const updatedResults = currentResults.concat(payload.results || []);

            if (stateNorm && stateNorm.data) {
                Vue.set(stateNorm.data, 'results', updatedResults);
                Vue.set(stateNorm.data, 'next', payload.next || '');
            } else {
                Vue.set(stateNorm, 'results', updatedResults);
                Vue.set(stateNorm, 'next', payload.next || '');
            }
        },
        // Shifts room order when a new live message arrives
        MOVE_CHAT_ROOM_TO_TOP(state, roomId) {
            const stateNorm = state.normalChatRoomsState;
            const results = stateNorm && stateNorm.results;
            if (results) {
                const itemIndex = results.findIndex(item => item.chat_room === roomId);
                if (itemIndex > 0) {
                    const [item] = results.splice(itemIndex, 1);
                    results.unshift(item);
                }
            }
        },
        // Live update socket online/device triggers
        UPDATE_CHAT_USER_ONLINE_STATUS(state, data) {
            const updateStatus = (list) => {
                // Explicitly check that list is an array before calling .find()
                if (list && Array.isArray(list)) {
                    const target = list.find(item => item.user && item.user.id === data.userID);
                    if (target && target.user) {
                        target.user.is_online = data.is_online;
                        if(data.device_type != 'mobile'){
                            target.user.browser_online = data.device_type === 'browser';
                        }
                    }
                }
            };
            
            const pinnedResults = state.pinnedChatRoomsState && state.pinnedChatRoomsState.results;
            if (pinnedResults) updateStatus(pinnedResults);

            const normalResults = state.normalChatRoomsState && state.normalChatRoomsState.results;
            if (normalResults) updateStatus(normalResults);
        },
        // Live update manual user profile status tags (e.g. Lunch Away, Busy)
        UPDATE_CHAT_USER_CUSTOM_STATUS(state, data) {
            const updateCustom = (list) => {
                if (list && Array.isArray(list)) {
                    const target = list.find(item => item.user && item.user.id === data.userID);
                    if (target && target.user) {
                        target.user.current_status = data.current_status;
                        target.user.status_time = data.status_time;
                    }
                }
            };

            const pinnedResults = state.pinnedChatRoomsState && state.pinnedChatRoomsState.results;
            if (pinnedResults) updateCustom(pinnedResults);

            const normalResults = state.normalChatRoomsState && state.normalChatRoomsState.results;
            if (normalResults) updateCustom(normalResults);
        },
        // Live unread counter updater
        UPDATE_CHAT_ROOM_UNREAD_COUNT(state, { roomId, count }) {
            const updateCount = (list) => {
                if (list && Array.isArray(list)) {
                    const target = list.find(item => item.chat_room === roomId);
                    if (target) target.unread_count = count;
                }
            };

            
            const pinnedResults = state.pinnedChatRoomsState && state.pinnedChatRoomsState.results;
            if (pinnedResults) updateCount(pinnedResults);

            const normalResults = state.normalChatRoomsState && state.normalChatRoomsState.results;
            if (normalResults) updateCount(normalResults);
        },
        // Clears specific unread badges on entry
        CLEAR_CHAT_ROOM_UNREAD_COUNT(state, roomId) {
            const clearCount = (list) => {
                if (list && Array.isArray(list)) {
                    const target = list.find(item => item.chat_room === roomId);
                    if (target) target.unread_count = 0;
                }
            };

            const pinnedResults = state.pinnedChatRoomsState && state.pinnedChatRoomsState.results;
            if (pinnedResults) clearCount(pinnedResults);

            const normalResults = state.normalChatRoomsState && state.normalChatRoomsState.results;
            if (normalResults) clearCount(normalResults);
        }
    },
    actions: {
        // get Pinned Chat Rooms Action
        fetchPinnedChatRooms(context, payload) {
            context.commit('SET_PINNED_LOADED', false);
            return new Promise((resolve, reject) => {
                axios.get(fetchPinnedChatRoomsApiUrl, payload).then(res => {
                    context.commit('SET_PINNED_CHAT_ROOMS', res.data);
                    context.commit('SET_PINNED_LOADED', true);
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // get Normal Chat Rooms Action
        fetchNormalChatRooms(context, payload) {
            context.commit('SET_NORMAL_LOADED', false);
            return new Promise((resolve, reject) => {
                axios.get(fetchNormalChatRoomsApiUrl, payload).then(res => {
                    context.commit('SET_NORMAL_CHAT_ROOMS', res.data);
                    context.commit('SET_NORMAL_LOADED', true);
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Triggered inside handleScroll to chain additional pages safely
        loadMoreLeftChatListDetails(context, nestedFullChatPayload) {
            context.commit('APPEND_NORMAL_CHAT_ROOMS', nestedFullChatPayload);
        },
        // get User for chat Action
        searchWorkspaceUser(context, payload) {
            return new Promise((resolve, reject) => {
                axios.get(workspaceUserSearchApiURL + '?q=' + payload.search_term).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // get Message Search Action
        searchMessages(context, payload) {
            return new Promise((resolve, reject) => {
                axios.get(messageSearchApiUrl + '?q=' + payload.search_term + '&id=' + payload.id).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Group Delete Api Method Code Here
        deleteGroup(context, payload) {
            return new Promise((resolve, reject) => {
                axios.delete(groupDeleteApiUrl + payload.id + '/').then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Get User Name List From Group Function
        fetchGroupUserNames(context, payload) {
            return new Promise((resolve, reject) => {
                axios.get(getUserNameListFromGroupApiUrl + payload.id + '/').then(res => {
                    context.commit('SET_GROUP_USER_NAMES', res.data);
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Chat Room Pinned Function
        pinChatRoom(context, payload) {
            return new Promise((resolve, reject) => {
                axios.patch(chatRoomPinnedApiURL, payload).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // get All Left Chat List Details
        fetchLeftChatListDetails(context, payload) {
            return new Promise((resolve, reject) => {
                axios.get(allLeftChatListDetailsURL + '?screen_height=' + window.outerHeight, payload).then(res => {
                    context.commit('SET_LEFT_CHAT_LIST_DETAILS', res.data);
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Message Delete For Chat In Workspace
        deleteChatMessage(context, payload) {
            return new Promise((resolve, reject) => {
                axios.delete(deleteMsgApiURL + payload.data.id + '/?delete_for_everyone=' + payload.data.query).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Forward Message Api Function
        forwardMessagesToUsers(context, payload) {
            return new Promise((resolve, reject) => {
                axios.post(forwardMultiMsgUserApiLink, payload).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // User Search Chat In Workspace
        searchChatUser(context, payload) {
            return new Promise((resolve, reject) => {
                axios.get(chatWithUserSearchApiUrl + '?search_term=' + payload.query).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Get User Chat List Create
        fetchChatDetailsById(context, payload) {
            return new Promise((resolve, reject) => {
                axios.get(UserChatDetailsUrl + payload.id + '/', payload).then((res) => {
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                })
            })
        },


        // Remove Admin From Group
        removeAdminFromGroup(context, payload) {
            return new Promise((resolve, reject) => {
                axios.post(removedAdminFromGroupApiUrl, payload).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Make Group Api
        removeUserFromGroup(context, payload) {
            return new Promise((resolve, reject) => {
                axios.patch(userRemovedFromGroupApiURL + payload.data.id + '/', payload.data.data).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Make Group Api
        makeGroupAdmin(context, payload) {
            return new Promise((resolve, reject) => {
                axios.post(makeUserToGroupAdminApiURL, payload).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Get Group Chat Room List
        fetchGroupChatDetailsById(context, payload) {
            return new Promise((resolve, reject) => {
                axios.get(getGroupDetailsByIdApiURL + payload.id + '/').then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Update Group Details Fun
        updateGroupChatDetails(context, payload) {
            return new Promise((resolve, reject) => {
                axios.patch(updateGroupRoomDetailsApiURL + payload.data.id + '/', payload.data.data).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        // Leave Group Chat Room Of List
        leaveGroupRoomById(context, payload) {
            return new Promise((resolve, reject) => {
                axios.post(leaveGroupRoomApiURL, payload).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
    },
    getters: {
        leftChatListDetailsGetters: state => state.leftChatListDetailsState,
        pinnedChatRoomsGetters: state => state.pinnedChatRoomsState,
        normalChatRoomsGetters: state => state.normalChatRoomsState,
        groupUserNamesGetters: state => state.groupUserNamesState,
        isChatRoomLoaded: (state) => {
            return state.pinnedLoaded && state.normalLoaded;
        },
    }
}